import { cn } from "@/lib/utils";
import { Button } from "../ui/button";
import { XIcon } from "lucide-react";

type CustomErrorPopupProps = {
  title?: string;
  description?: string;
  message?: string;
  open: boolean;
  setOpen: (prop: boolean) => void;
};

export const CustomErrorPopup = ({
  title,
  description,
  message,
  open,
  setOpen,
}: CustomErrorPopupProps) => {
  const content = description ?? message ?? "";

  return (
    <div
      className={cn(
        " fixed top-3 right-4 bg-red-500 w-[400px] rounded-sm p-4",
        open ? "" : "hidden",
      )}
    >
      <div className="">
        <div className="text-sm font-semibold [&+div]:text-xs text-white">
          {title}
        </div>
        <div className="text-sm opacity-90 text-white mt-2 max-h-[300px] overflow-y-auto">
          {content}
        </div>
        <Button
          variant={"ghost"}
          size={"icon"}
          className="absolute top-1 right-2 text-white"
          onClick={() => setOpen(false)}
        >
          <XIcon />
        </Button>
      </div>
    </div>
  );
};
